import { Service } from "@roc/feature-app-core";

export const url = {
  GET_LEAD_LIST_BY_ID: '/api/v1/lender/cadences/getCadenceProspectsDashboardById',
  GET_CUSTOM_LEAD_LIST_BY_ID: '/api/v1/lender/cadences/getCustomCadenceProspectsDashboardById',
  GET_CUSTOM_DASHBOARDS: '/api/v1/lender/customDashboards/getCustomDashboards',
  CREATE_CADENCE: '/api/v1/lender/cadences/createCadence',
  CREATE_CADENCE_COPY: '/api/v1/lender/cadences/createCadenceCopy',
  UPDATE_CADENCE_NAME: '/api/v1/lender/cadences/updateCadenceName',
  GET_TEMPLATE_CADENCES: '/api/v1/lender/cadences/getCadenceTemplatesByUser',
  GET_CADENCE_DATA_CONTENT_BY_ID: '/api/v1/lender/cadences/getDataContentByCadenceId',
  GET_CADENCE_DATA_CONTENT_BY_ID_AND_USER: '/api/v1/lender/cadences/getDataContentByCadenceIdAndUserId',
  GET_CADENCE_DATA_CONTENT_WITH_PROSPECTS_BY_ID: '/api/v1/lender/cadences/getDataContentWithProspectsByCadenceId',
  CREATE_CADENCE_STEP: '/api/v1/lender/cadences/createCadenceStep',
  EDIT_CADENCE_STEP: '/api/v1/lender/cadences/editCadenceStep',
  ASSIGN_USERS_TO_CADENCE: '/api/v1/lender/cadences/assignCadenceToUsers',
  GET_USERS_ASSIGNED_TO_CADENCE: '/api/v1/lender/cadences/getOriginatorsAssociatedWithCadence',
  GET_CADENCE_STEP_DUE_FOR_BACKOFFICE_ORIGINATORS: '/api/v1/lender/cadences/getCadenceStepDueForBackOfficeUser',
  GET_CADENCE_STEP_DUE_FOR_BACKOFFICE_ORIGINATORS_AND_CADENCE_ID: '/api/v1/lender/cadences/getCadenceStepDueForBackOfficeUserAndCadenceId',
  SAVE_LIST_VIEW_ID: '/api/v1/lender/cadences/saveListViewId',
  COMPLETE_CALL_STEP_FOR_CADENCE_CONTACTS: '/api/v1/lender/cadences/completeCallStepForCadenceContacts',
  MARK_CADENCE_CONTACTS_AS_UNSUBSCRIBED: '/api/v1/lender/cadences/markCadenceContactAsUnsubscribed',
  GET_PROSPECTS_BY_ORIGINATOR_CUSTOM_LIST: '/api/v1/lender/cadences/getProspectsByOriginatorForCustomList',
  GET_PROSPECTS_BY_ORIGINATOR_STANDARD_LIST: '/api/v1/lender/cadences/getProspectsByOriginatorForStandardList',
  ADD_MORE_PROSPECTS: '/api/v1/lender/cadences/addExtraProspectsToPartialList',
  REMOVE_PROSPECT: '/api/v1/lender/cadences/removeProspectFromPartialList',
  PAUSE_CADENCE: '/api/v1/lender/cadences/pauseCadence',
  RESUME_CADENCE: '/api/v1/lender/cadences/resumeCadence',
  GET_CADENCE_OPTIONS: '/api/v1/lender/cadences/getCadenceOptions',
  ADD_PROSPECTS_TO_CADENCE: '/api/v1/lender/cadences/addProspectsToCadence',
  GET_PROSPECTS_BY_ORIGINATOR: '/api/v1/lender/cadences/getProspectsByOriginator',
  GET_PROSPECTS: '/api/v1/lender/cadences/getProspects',
  GET_OWNERS: '/api/v1/lender/cadences/getOwnerByTemplateId',
  DELETE_CADENCE: '/api/v1/lender/cadences/deleteCadence'
};

export class CadenceService extends Service {

  getLeadsListById(listId: string, setupId: number, pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string, businessUnit: string, isAddingMoreProspectsActive: boolean) {
    return this.get(url.GET_LEAD_LIST_BY_ID,
      { listId, setupId, pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters, businessUnit, addingMoreProspects: isAddingMoreProspectsActive },
      { disableGlobalLoading: true }
    );
  }

  getCustomLeadsListById(listId: string, setupId: number, pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string, businessUnit: string, isAddingMoreProspectsActive: boolean) {
    return this.get(url.GET_CUSTOM_LEAD_LIST_BY_ID,
      { listId, setupId, pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters, businessUnit, addingMoreProspects: isAddingMoreProspectsActive },
      { disableGlobalLoading: true }
    );
  }

  saveListViewId(cadenceId, listInfo) {
    return this.post(`${url.SAVE_LIST_VIEW_ID}?cadenceId=${cadenceId}`, listInfo);
  }

  completeCallStepForCadenceContacts(cadenceContactsId) {
    return this.post(`${url.COMPLETE_CALL_STEP_FOR_CADENCE_CONTACTS}`, cadenceContactsId);
  }

  markCadenceContactAsUnsubscribed(cadenceContactsId, reason) {
    return this.post(`${url.MARK_CADENCE_CONTACTS_AS_UNSUBSCRIBED}?reason=${reason}`, cadenceContactsId);
  }

  getCustomDashboards() {
    return this.get(url.GET_CUSTOM_DASHBOARDS);
  }

  createCadence(cadenceInfo) {
    return this.post(url.CREATE_CADENCE, cadenceInfo);
  }

  copyCadence(cadenceInfo) {
    return this.post(url.CREATE_CADENCE_COPY, cadenceInfo);
  }

  updateCadenceName(cadenceInfo) {
    return this.post(url.UPDATE_CADENCE_NAME, cadenceInfo);
  }

  getCadenceTemplatesByUser(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: string,
    dropdownFilters: object,
    callingFromMyCadences: boolean) {
    return this.get(url.GET_TEMPLATE_CADENCES,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        callingFromMyCadences
      }
    );
  }

  getDataContentByCadenceId(cadenceId, callingFromMyCadences) {
    return this.get(url.GET_CADENCE_DATA_CONTENT_BY_ID, { cadenceId, callingFromMyCadences });
  }

  getDataContentByCadenceIdAndUserId(cadenceId, userId) {
    return this.get(url.GET_CADENCE_DATA_CONTENT_BY_ID_AND_USER, { cadenceId, userId });
  }

  getDataContentWithProspectsByCadenceId(cadenceId, callingFromMyCadences) {
    return this.get(url.GET_CADENCE_DATA_CONTENT_WITH_PROSPECTS_BY_ID, { cadenceId, callingFromMyCadences });
  }

  createCadenceStep(stepInfo, cadenceId) {
    return this.post(`${url.CREATE_CADENCE_STEP}?cadenceId=${cadenceId}`, stepInfo);
  }

  editCadenceStep(stepInfo, cadenceId) {
    return this.post(`${url.EDIT_CADENCE_STEP}?cadenceId=${cadenceId}`, stepInfo);
  }

  assignUsersToCadences(userIds) {
    return this.post(url.ASSIGN_USERS_TO_CADENCE, userIds);
  }

  getOriginatorsAssociatedWithCadence(cadenceId) {
    return this.get(url.GET_USERS_ASSIGNED_TO_CADENCE, { cadenceId });
  }

  getCadenceStepDueForBackOfficeUser() {
    return this.get(url.GET_CADENCE_STEP_DUE_FOR_BACKOFFICE_ORIGINATORS);
  }

  getCadenceStepDueForBackOfficeUserAndCadenceId(cadenceId) {
    return this.get(url.GET_CADENCE_STEP_DUE_FOR_BACKOFFICE_ORIGINATORS_AND_CADENCE_ID, { cadenceId });
  }

  getProspectsByOriginatorForStandardList(listId: number, setupId: number, pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string, businessUnit: string) {
    return this.get(url.GET_PROSPECTS_BY_ORIGINATOR_STANDARD_LIST,
      { listId, setupId, pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters, businessUnit },
      { disableGlobalLoading: true }
    );
  }

  getProspectsByOriginatorForCustomList(listId: number, setupId: number, pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string, businessUnit: string) {
    return this.get(url.GET_PROSPECTS_BY_ORIGINATOR_CUSTOM_LIST,
      { listId, setupId, pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters, businessUnit },
      { disableGlobalLoading: true }
    );
  }

  addNewProspects(setupId, prospectsIds) {
    return this.post(`${url.ADD_MORE_PROSPECTS}?setupId=${setupId}`, prospectsIds);
  }

  removeProspect(prospectId: number, setupId: number, businessUnit: string) {
    return this.delete(`${url.REMOVE_PROSPECT}?prospectId=${prospectId}&setupId=${setupId}&businessUnit=${businessUnit}`);
  }

  pauseCadence(cadenceId: number, reason: string) {
    return this.post(`${url.PAUSE_CADENCE}?cadenceId=${cadenceId}&reason=${reason}`, {});
  }

  resumeCadence(cadenceId: number) {
    return this.post(`${url.RESUME_CADENCE}?cadenceId=${cadenceId}`, {});
  }

  cadenceOptions(listType: string) {
    return this.get(`${url.GET_CADENCE_OPTIONS}?type=${listType}`);
  }

  addProspectsToCadence(prospectsIds, listType: string, businessUnit: string, cadenceSetupId: number) {
    return this.post(`${url.ADD_PROSPECTS_TO_CADENCE}?type=${listType}&businessUnit=${businessUnit}&cadenceSetupId=${cadenceSetupId}`, prospectsIds);
  }

  getProspectsByOriginator(templateId: number) {
    return this.get(`${url.GET_PROSPECTS_BY_ORIGINATOR}?templateId=${templateId}`);
  }

  getProspects(templateId: number, pageNumber: number, pageSize: number, sortBy: string, sortDir: string, filters: string, dropdownFilters: string) {
    return this.get(url.GET_PROSPECTS,
      { templateId, pageNumber, pageSize, sortBy, sortDir, filters, dropdownFilters },
      { disableGlobalLoading: true }
    );
  }

  getOwners(templateId: number) {
    return this.get(url.GET_OWNERS + '?templateId=' + templateId);
  }

  deleteCadence(templateId: number) {
    return this.delete(url.DELETE_CADENCE + '?templateId=' + templateId);
  }

}
